import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { Layout } from '@/components/generals/layout'
import { Seo } from '@/components/generals/seo'
import SiteHeader from '@/components/landing/site-header'

interface PageShellProps {
    title: string
    description?: string
    width?: 'narrow' | 'medium' | 'wide'
    children: ReactNode
}

const WIDTHS = {
    narrow: 'max-w-md',
    medium: 'max-w-3xl',
    wide: 'max-w-6xl'
}

/* Inner pages: the solid site header, the shared footer and a centred column. */
const PageShell: FC<PageShellProps> = ({ title, description, width = 'wide', children }): ReactNode => {
    return (
        <Layout header={<SiteHeader solid />}>
            <Seo title={title} description={description} />

            <div className='bg-background text-cream'>
                <div className={cn('mx-auto px-5 pb-24 pt-28 sm:px-8 sm:pt-32', WIDTHS[width])}>
                    {children}
                </div>
            </div>
        </Layout>
    )
}

export default PageShell
